import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {PasswordApiModel} from './password.api-model';
import {MediaObjectApiModel} from './media-object.api-model';
import {PersonalInformationApiModel} from "./personal-information.api.model";
import {SocialProfileLinksInterface} from "../interfaces/social-profile-links.interface";
import {SettingsInterface} from "../interfaces/settings.interface";

@Exclude()
export class UserApiModel extends AbstractApiModel {

  @Expose() public id: number;
  @Expose() public reputationRank?: string | null;
  @Expose() public username: string;
  @Expose() public name: string;
  @Expose() public email: string | null;
  @Expose() public password: PasswordApiModel;
  @Expose() public slug: string | null;
  @Type(() => MediaObjectApiModel)
  @Expose() public avatar: MediaObjectApiModel|string|null;
  @Type(() => MediaObjectApiModel)
  @Expose() public background: MediaObjectApiModel|string|null;
  @Expose() public images: string[];
  @Type(() => PersonalInformationApiModel)
  @Expose() public info: PersonalInformationApiModel|string;
  @Expose() public socialProfile: SocialProfileLinksInterface;
  @Expose() public instagramProfileUrl: string | null;
  @Expose() public instagramLinkedUsername: string | null;
  @Expose() public instagramIntegrationStatus: string | null;
  @Expose() public instagramSyncLimitations: string[] = [];
  @Expose() public instagramProfileMismatch: boolean = false;
  @Expose() public settings: SettingsInterface;
  @Expose() public roles: string[];
  @Expose() public currentPassword: string;
  @Expose() public projects: string[];
  @Expose() public follows: string[];
  @Expose() public reactions: string[];
  @Expose() public savedMarketplaceAdvertisements: string[];
  @Expose() public individualProjects: number;
  @Expose() public collaborationProjects: number;
  @Expose() public saleProjects: number;
  @Expose() public soldProjects: number;
  @Expose() public createdAt: Date;
  @Expose() public updatedAt: Date;
  @Expose({groups: [ 'admin:user-read' ]}) public frozen: boolean;
  @Expose() public enabled: boolean;
  @Expose() public deleted: boolean = false;
  @Expose() public completedAt: Date;
  @Expose({groups: [ 'admin:user-read' ]}) public terms: boolean;
}
